import * as React from 'react';
import { ObjectsHelper } from 'utils';

import './style.scss';
import { AutoScrollbars } from 'components';
import clsx from 'clsx';

export interface IObjectTocProps {
    object: omjs.IObjectJSON;
    structure: ObjectsHelper.IModifiedStructureColumn[];
    layerConfig: omjs.ILayerConfig;
    onHeaderClick: (column: ObjectsHelper.IModifiedStructureColumn) => any;
    className?: string;
}
export interface IObjectTocState {}


class ObjectTocComponent extends React.Component<IObjectTocProps, IObjectTocState> {
    constructor(props: IObjectTocProps) {
        super(props);

        this.renderTOCItem = this.renderTOCItem.bind(this);
    }

    getHeaderColumns() {
        return this.props.structure.filter(s => s.level === 0 && !!s.name.length);
    }

    renderTOCItem(
        column: ObjectsHelper.IModifiedStructureColumn,
        index: number,
        structure: ObjectsHelper.IModifiedStructureColumn[]
    ) {
        return (
            <li
                onClick={() => {
                    this.props.onHeaderClick(column);
                }}
                key={column.code}
            >
                {column.name}
            </li>
        );
    }

    render() {
        return (
            <AutoScrollbars className={this.props.className}>
                <div className={clsx('table-of-content')}>
                    <ul>
                        {this.getHeaderColumns().map(this.renderTOCItem)}
                    </ul>
                </div>
            </AutoScrollbars>
        );
    }
}

export const ObjectToc = ObjectTocComponent;
